import React from "react";
import PaymentHistoryTable from "./PaymentHistoryTable/PaymentHistoryTable";
import './PaymentHistoryHome.css';
import PaymentAttempts from "./PaymentAttempts/PaymentAttempts";

function PaymentHistoryHome() {
    
    return (
        <div>
        <div className='payment-history-container'>
            <PaymentHistoryTable/>
        </div>

        <div className='payment-history-container'>
            <PaymentAttempts/>
        </div>
            
        </div>

    );
}
export default PaymentHistoryHome; 